/* Shared system motion state. No manual controls, saved preference or network. */
(function (global) {
  'use strict';
  if (global.YulFishMotionPreference) return;
  const reduced = global.matchMedia?.('(prefers-reduced-motion: reduce)');
  let lastState = '';
  function state() {
    const reducedMotion = !!reduced?.matches, documentHidden = !!document.hidden;
    return {paused:reducedMotion || documentHidden, reducedMotion, documentHidden};
  }
  function sync() {
    const current = state();
    document.documentElement.setAttribute('data-yf-motion', current.paused ? 'paused' : 'auto');
    return current;
  }
  function publish() {
    const current = sync(), signature = JSON.stringify(current);
    if (signature === lastState) return;
    lastState = signature;
    document.dispatchEvent(new CustomEvent('yulfish:motion-preference', {detail:current}));
  }
  global.YulFishMotionPreference = Object.freeze({
    version:2,
    get paused() { return state().paused; },
    get reducedMotion() { return !!reduced?.matches; },
    sync
  });
  document.addEventListener('visibilitychange', publish);
  if (reduced?.addEventListener) reduced.addEventListener('change', publish);
  else reduced?.addListener?.(publish);
  publish();
})(window);
